module.exports = __webpack_public_path__ + "assets/img/2.830ecd8a.jpg";